/**
 *  Hud
 *
 *  Created by Legman on 23/02/2017.
 *
 */

import Common from "./Common";

/**
 * @class
 */
export default class Hud extends PIXI.Container {
    constructor() {
        super();

        const assets = Common.assets;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._hand = new PIXI.Sprite(assets.getTexture("tutorial_hand"));
        this._hand.x = Common.STAGE_WIDTH * 0.5 + 60;
        this._hand.y = Common.STAGE_HEIGHT * 0.5 + 40;
        this._hand.anchor = new PIXI.Point(0.5, 0.5);
        this._hand.hitArea = new PIXI.Rectangle();
        this._hand.visible = false;
        this.addChild(this._hand);

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._bestScore = new PIXI.Sprite(assets.getTexture("ui_best"));
        this._bestScore.anchor = new PIXI.Point(0.5, 0.5);
        this._bestScore.hitArea = new PIXI.Rectangle();
        this._bestScore.visible = false;
        this.addChild(this._bestScore);

        if (webfont) {
            this._bestScore.title = new PIXI.Text(translate("game_best_score"),
                {fontSize: "42px", fontFamily: "Arial", fill: "0xFFFFFF", align: "center"});
            this._bestScore.title.y = -42;
            this._bestScore.title.pivot.x = this._bestScore.title.width * 0.5;
            this._bestScore.title.pivot.y = this._bestScore.title.height;
            this._bestScore.addChild(this._bestScore.title);
        } else {
            this._bestScore.title = new PIXI.extras.BitmapText(translate("game_best_score"),
                {font: "42px Cloudy Bold", align: "center"});
            this._bestScore.title.y = -42;
            this._bestScore.title.pivot.x = this._bestScore.title.textWidth * 0.5;
            this._bestScore.title.pivot.y = this._bestScore.title.textHeight;
            this._bestScore.addChild(this._bestScore.title);
        }

        if (webfont) {
            this._bestScore.score = new PIXI.Text("0",
                {fontSize: "60px", fontFamily: "Arial", fill: "0xFFFFFF", align: "center"});
            this._bestScore.score.pivot.x = this._bestScore.score.width * 0.5;
            this._bestScore.score.pivot.y = this._bestScore.score.height * 0.5;
            this._bestScore.addChild(this._bestScore.score);
        } else {
            this._bestScore.score = new PIXI.extras.BitmapText("0",
                {font: "60px Cloudy Bold", align: "center"});
            this._bestScore.score.pivot.x = this._bestScore.score.textWidth * 0.5;
            this._bestScore.score.pivot.y = this._bestScore.score.textHeight * 0.5;
            this._bestScore.addChild(this._bestScore.score);
        }

        const config = assets.getJSON("best");
        this._bestScore.emitter = new PIXI.particles.Emitter(this._bestScore,
            [assets.getTexture("particle_replicator_001")], config);
        this._bestScore.emitter.emit = false;

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_pause_off");

        this._pauseButton = new p3.Button(states);
        this._pauseButton.visible = false;
        this._pauseButton.overSoundName = "sfx_btn_press_00";
        this._pauseButton.clickSoundName = "sfx_btn_home_00";
        this.addChild(this._pauseButton);

        this.on("added", this.init, this);
    }

    init() {
        this.off("added", this.init);
    }

    destroy(destroyChildren) {
        this._bestScore.emitter.clear();

        super.destroy(destroyChildren);
    }

    update() {
        this._bestScore.emitter.update(deltaTime);
    }

    resize() {
        this._bestScore.x = 120;
        this._bestScore.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

        this._pauseButton.x = p3.View.width - 100;
        this._pauseButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
    }

    /**
     * @param {!number} value
     * @param {PIXI.Point} position
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateScorePopup(value, position, callback, scope) {
        const popup = new PIXI.Container();
        popup.x = position.x;
        popup.y = position.y;
        this.addChildAt(popup, 0);

        popup.label = new PIXI.extras.BitmapText(translate("game_score_popup").replace("[VALUE]", value), {font: "60px Cloudy Bold", align: "center"});
        popup.label.pivot.x = popup.label.textWidth * 0.5;
        popup.label.pivot.y = popup.label.textHeight * 1.4;
        popup.addChild(popup.label);

        const tl = new TimelineMax({onComplete: function() {
            popup.parent.removeChild(parent);
            popup.destroy();

            callback && callback.call(scope);
        }, onCompleteScope: this});

        popup.scale = new PIXI.Point();
        tl.append(TweenMax.to(popup.scale, 0.32, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [3]
        }));
        tl.append(TweenMax.to(popup, 0.2, {
            alpha: 0.0,
            ease: Power1.easeInOut
        }));
    }

    animateBestScore() {
        this._bestScore.emitter.emit = true;

        TweenMax.killTweensOf(this._bestScore.scale);

        const tl = new TimelineMax();
        tl.append(TweenMax.to(this._bestScore.scale, 0.2, {
            x: 1.16,
            y: 1.16,
            ease: Power0.easeNone
        }));
        tl.append(TweenMax.to(this._bestScore.scale, 0.16, {
            x: 1,
            y: 1,
            ease: Power2.easeInOut
        }));
    }

    /**
     * @param {!number} value
     */
    updateBestScore(value) {
        this._bestScore.score.text = value.toString();
        if (webfont) {
            this._bestScore.score.pivot.x = this._bestScore.score.width * 0.5;
        } else {
            this._bestScore.score.pivot.x = this._bestScore.score.textWidth * 0.5;
        }
    }

    startIntroAnimation() {
        this._hand.alpha = 0;
        TweenMax.to(this._hand, 0.2, {
            delay: 0.2,
            alpha: 1,
            ease: Power1.easeInOut,
            onStart: function() {
                this._hand.visible = true;
            },
            onStartScope: this
        });

        const tl = new TimelineMax({delay: 1, repeat: -1});
        tl.insert(TweenMax.to(this._hand.scale, 0.2, {
            x: 0.9,
            y: 0.9,
            ease: Back.easeOut,
            yoyo: true,
            repeat: 1
        }));
        tl.insert(TweenMax.delayedCall(1.4, function() {}));
    }

    stopIntroAnimation() {
        TweenMax.to(this._hand, 0.2, {
            alpha: 0,
            ease: Power1.easeInOut,
            onComplete: function() {
                TweenMax.killTweensOf(this._hand);
                this._hand.visible = false;
            },
            onCompleteScope: this
        });
    }

    /**
     * @returns PIXI.Sprite
     */
    get bestScore() {
        return this._bestScore;
    }

    /**
     * @returns {p3.Button}
     */
    get pauseButton() {
        return this._pauseButton;
    }
}
